import axios from 'axios';
import authHeader from '../../auth-header';

import tokenHeader from '../../token-header';

import Utils from '../../utils.service';

const API_URL = Utils.baseUrlLms() + "/";

const getDataPesertaLms = 'data-peserta-lms';
const getPelatihan = 'get-all-lms';
const putSkpPeserta = 'data-peserta-lms/edit-skp/';
const importDataSkpPeserta = 'data-peserta-lms/import-skp';
const downloadSKP = 'data-peserta-lms/export-skp/';


class DataPesertaPelatihanLmsService {
    getDataPeserta(
        currentPage,
        pageSize,
        id_pelatihan,
        filter
    ) {
        
        var data = {
            page: currentPage,
            pageSize: pageSize,
            id_pelatihan: id_pelatihan,
            filter: filter
        }
        return axios.get(
            API_URL + getDataPesertaLms,
            {
                params: data,
                headers: authHeader()
            });
    }

    ubahSkpPeserta(formData) {
        var form = {
            skp_terstruktur : formData.skp_terstruktur,
            skp_tidak_terstruktur : formData.skp_tidak_terstruktur,
            skp_assessment : formData.skp_assessment
        }
        return axios.put(
            API_URL + putSkpPeserta + formData.id_pelatihan_peserta,
            form,
            {
                headers: authHeader()
        });
    }

    getPelatihan() {
        return axios.get(
            API_URL + getPelatihan, {
            headers: authHeader()
        });

    }

    downloadSKP(pelatihan) {
        return axios.get(
            API_URL + downloadSKP + pelatihan,
            {
                headers: authHeader(),
                responseType: 'blob'
            });
    }

    importDataSkpPeserta(file) {
        const form = new FormData();
        form.append('file', file);
        return axios.post(API_URL + importDataSkpPeserta, form, {
            headers: { 'Content-Type': 'multipart/form-data', 'Authorization': tokenHeader() }
        });
    }

}

export default new DataPesertaPelatihanLmsService();